import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { LowerCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { FormatDurationPipe } from "../../../helpers/datehelper/duration";
import { AuthService } from "../../../services/authservice";
import { DialogAuthComponent } from "../../dialogs/dialog-auth/dialog-auth";

@Component({
  selector: "selfservice-status",
  templateUrl: "./selfservice-status.html",
  styleUrl: "./selfservice-status.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LowerCasePipe, AngularSvgIconModule, FormatDurationPipe, TranslatePipe],
})
export class SelfserviceStatus {
  private auth = inject(AuthService);
  private dialog = inject(MatDialog);

  protected selfserviceStarted = computed(() => this.auth.selfServiceStarted());
  protected tokenValidFor = computed(() => this.auth.selfServiceTokenValidFor());

  protected startSelfService() {
    this.dialog.open(DialogAuthComponent, { data: { state: false } });
  }
}
